import { render, staticRenderFns } from "./Messaggi.vue?vue&type=template&id=4e6f52dd&scoped=true&"
import script from "./Messaggi.vue?vue&type=script&lang=js&"
export * from "./Messaggi.vue?vue&type=script&lang=js&"
import style0 from "./Messaggi.vue?vue&type=style&index=0&id=4e6f52dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6f52dd",
  null
  
)

export default component.exports